import { EventBus } from 'core-components/classes/events/Bus'

export const socketEventBus = new EventBus(['opened', 'closed'], 'Socket')
export const connectionStatusBus = new EventBus(['changeStatus'], 'ConnectionStatus')
